import { DialogContent, Select, Avatar, Box, Typography, TextField } from '@material-ui/core'
import { Close } from '@material-ui/icons'
import styled from 'styled-components'

import { ReactComponent as ImageUploadIcon } from 'icons/image-upload.svg'
import { ReactComponent as ResumeUploadIcon } from 'icons/resume-upload.svg'
import { InputField } from 'pages/content/components/jobs/components/molecules'
import { Button } from 'common/atoms/Button/Button'
import { boolean } from 'yup'

export const Container = styled.div``

export const StyledTextField = styled(TextField)`
  && .MuiInputBase-root {
    width: 100%;
    background-color: ${({ theme }) => theme.colors.bgPrimary};
  }
`
export const StyledUploadIcon = styled(ImageUploadIcon)`
  stroke: ${({ theme }) => theme.colors.primary};
  fill: ${({ theme }) => theme.colors.primary};
  min-height: 2rem;
  max-height: 3rem;
  min-width: 2rem;
  max-width: 3rem;
`
export const StyledResumeIcon = styled(ResumeUploadIcon)`
  stroke: ${({ theme }) => theme.colors.accent};
  fill: ${({ theme }) => theme.colors.supplementary};
  min-height: 2rem;
  max-height: 3rem;
  min-width: 2rem;
  max-width: 3rem;
`

export const FileInput = styled.input`
  display: none;
`
export const RemoveResumeButton = styled(Button)`
  && {
    color: ${({ theme }) => theme.colors.error};
  }
`

export const ContentBody = styled.div`
  padding: 10px 20px 31px;
`
export const ContentBodyMobile = styled.div`
  border-radius: 30px;
  color: ${({ theme }) => theme.colors.accent1} !important;
  background-color: ${({ theme }) => theme.colors.supplementary};
  margin: 0.938rem 0.75rem;
`
export const StyledInputField = styled(InputField)`
  border-width: 1px !important;
  background-color: ${({ theme }) => theme.colors.supplementary1} !important;
`
export const SubmitButton = styled(Button)`
  && {
    font-weight: bold;
    font-size: 16px;
    text-transform: uppercase;
  }
`
export const StyledDialogContent = styled(DialogContent)`
  position: relative;
  max-width: 100% !important;
  overflow: hidden !important;
  background-color: ${({ theme }) => theme.colors.supplementary};
  padding: 0px !important;
  margin: 0px !important;
  color: ${({ theme }) => theme.colors.accent1};
`

export const StyledSelect = styled(Select)`
  && {
    background-color: ${({ theme }) => theme.colors.bgPrimary} !important;
    color: ${({ theme }) => theme.colors.accent1};
    border: solid 1px ${({ theme }) => theme.colors.accent1};
    border-radius: 16px;
    width: 100%;
    margin-right: 0.8rem;
    @media (max-width: 720px) {
      width: 50%;
    }
  }
`
export const MobileTitle = styled(Typography)`
  && {
    font-weight: bold;
  }
`
export const StyledPhoneInputBox = styled(Box)`
  && {
    display: flex;
  }
`
export const AvatarContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 1.938rem 0 1.875rem 0;
  justify-content: center;
  text-align: center;
  gap: 0.5rem;
`
export const AvatarTitle = styled(Typography)`
  && {
    text-transform: capitalize;
    font-weight: bold;
    color: ${({ theme }) => theme.colors.accent1};
    margin-bottom: 1px;
    @media (max-width: 720px) {
      font-size: 16px;
    }
  }
`
export const AvatarSubtitle = styled(Typography)`
  && {
    text-transform: capitalize;
    color: ${({ theme }) => theme.colors.accent};
    @media (max-width: 720px) {
      font-size: 14px;
    }
  }
`
export const Title = styled(Typography)`
  && {
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${({ theme }) => theme.colors.accent1};
    text-transform: capitalize !important;
    text-align: center;
    font-size: 24px;
    width: 100%;
    font-weight: 700px;
    @media (max-width: 720px) {
      width: 96%;
      word-wrap: break-word;
      font-size: 16px;
      margin: 10px 2px;
      justify-content: flex-start;
      text-transform: capitalize;
      font-weight: bold;
    }
  }
`
export const BackButton = styled(Button)`
  && {
    color: ${({ theme }) => theme.colors.accent1};
  }
`
export const CloseIcon = styled(Close)`
  color: ${({ theme }) => theme.colors.accent1};
`

export const StyledAvatar = styled(Avatar)`
  && {
    margin-right: 12px;
    width: 6.25rem;
    height: 6.25rem;
  }
`

export const UploadBoxContainer = styled(Box)`
  margin-top: 10px;
  position: relative;
  width: 100%;
  height: 200px;
  @media (max-width: 720px) {
    min-height: 200px;
    max-height: 300px;
  }
`
export const UploadOverlay = styled.div`
  position: absolute;
  z-index: 1;
  top: 0px;
  bottom: 0px;
  right: 0px;
  left: 0px;
  opacity: 0.9;
  height: 100%;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.supplementary};
`
export const UploadBox = styled(Box) <{isDevice: boolean}>`
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  text-align: center;
  background-color: ${({ theme }) => theme.colors.bgPrimary};
  border-radius: 12px;
  margin-top: 1rem;
  padding: ${props => (props.isDevice ? ' 2.188rem 1.188rem' : '2.188rem')};
`
export const FileSelectBox = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  cursor: pointer;
  padding: 40px;
  width: 100%;
  height: 100%;
  @media (max-width: 720px) {
    padding: 0px;
  }
`
export const FileSelectBoxContainer = styled(Box)`
  width: 100%;
  height: 100%;
`
export const SwitchContainer = styled(Box)`
  padding: 10px 9px 20px;
`
export const StyledLabel = styled(Typography)`
  && {
    margin: 0.5rem 0;
    font-weight: bold;
    padding-left: 0.75rem;
  }
`
export const ErrorText = styled(Typography)`
  && {
    display: flex;
    flex-direction: row-reverse;
    padding: 0px;
    margin: 0.2rem 0 0;
    font-weight: 500;
    color: ${({ theme }) => theme.colors.error};
    @media (max-width: 720px) {
      font-size: 12px;
      font-weight: 400;
    }
  }
`
